import React from "react";

import classnames from "classnames";
import { UNSUPPORTED_DISABILITY_SIC_CODES } from "EmployerApplication/Components/Constants";
import { SICCodeSearch } from "EmployerApplication/Components/FinalFormQuestions";
import createDecorator from "final-form-focus";
import isIntuit from "Intuit/isIntuit";
import { Form } from "react-final-form";

import Button from "Cobalt/Button";
import { TitleSmall } from "Cobalt/Header";
import { ModalBody, ModalFooter } from "Cobalt/Modal";
import BodyText from "Common/BodyText";
import { Row, Col } from "Common/Grid";
import Icon from "Common/Icon";
import { SizeSwitch } from "Common/Responsive";

import makeBem from "Utils/makeBem";

const bem = makeBem("AddAncillaryPlanModal");
const focusOnErrors = createDecorator();

export const SICPage = ({ setCurrentPage, submitHandler, initialValues, shouldPrefillSICCode }) => {
  const previousPage = "businessTenurePage";
  const pageNumber = 2;
  const totalPages = 4;

  const isUnsupportedSICCode = (values) => UNSUPPORTED_DISABILITY_SIC_CODES.includes(values?.company_application?.sic_code);

  return (
    <Form onSubmit={submitHandler} decorators={[focusOnErrors]} initialValues={initialValues} keepDirtyOnReinitialize>
      {({ handleSubmit, submitting, form }) => (
        <form onSubmit={handleSubmit}>
          <ModalBody className={isIntuit() ? classnames(bem("body-intuit"), bem("sicLifePage")) : classnames(bem("body"), bem("sicLifePage"))}>
            <TitleSmall mt={0} mb={2}>
              Enter keywords that describe your business and select the best match
            </TitleSmall>
            <BodyText pb={4} ml={1}>
              The pricing for disability insurance varies depending on the nature and risk profile of the business.
              <br />
              Select from the list of standard industrial classification (SIC) codes to receive an exact quote for your business.
            </BodyText>
            <SICCodeSearch shouldPrefillSICCode={shouldPrefillSICCode} isDisability />
          </ModalBody>
          <ModalFooter className="text-left">
            <SizeSwitch
              sm={
                <Row className={bem("numberedFooter")}>
                  {previousPage ? (
                    <Button color="tertiary" className="pull-left" onClick={() => setCurrentPage(previousPage)}>
                      <Icon icon="chevron-left" pr={3} />
                      Back
                    </Button>
                  ) : null}
                  <BodyText className={bem("modalPageNumber")} size="small" pl={4}>
                    Step {pageNumber} / {totalPages}
                  </BodyText>
                  <Col md={9}>
                    {!isUnsupportedSICCode(form.getState().values) ? (
                      <Button color="primary" className="float-right" type="submit" disabled={submitting} mr={2}>
                        Continue
                      </Button>
                    ) : (
                      <Button color="primary" className="float-right" type="submit" disabled={submitting} mr={2}>
                        Finish
                      </Button>
                    )}
                  </Col>
                </Row>
              }
              xs={
                <div className={bem("mobileFooter")}>
                  <Button color="white" fullWidth onClick={() => setCurrentPage(previousPage)}>
                    Back
                  </Button>
                  {!isUnsupportedSICCode(form.getState().values) ? (
                    <Button color="primary" type="submit" disabled={submitting} fullWidth>
                      Continue
                    </Button>
                  ) : (
                    <Button color="primary" type="submit" disabled={submitting} fullWidth>
                      Finish
                    </Button>
                  )}
                </div>
              }
            />
          </ModalFooter>
        </form>
      )}
    </Form>
  );
};
